// extracted by mini-css-extract-plugin
export default {"parent":"supportAttachment_parent__cQs+1","parentPreview":"supportAttachment_parentPreview__B+RsH"};